module.exports = __webpack_public_path__ + "static/media/Golden_Underline@3x.bafc5289.png";